import CardListsSortableCardController from "../../../card_lists/assets/javascript/card-lists-sortable-card-controller";
import { createCustomEvent } from "../../../../javascript/shared/helpers";

export default class extends CardListsSortableCardController {

  connect() {
    super.connect()
    this.updateMilestonesAndListItems = this.updateMilestonesAndListItems.bind(this);
    this.refreshAfterCheckboxUpdate   = this.refreshAfterCheckboxUpdate.bind(this);
    this.toggleCompleted              = this.toggleCompleted.bind(this);
    this.refreshIfInMilestone         = this.refreshIfInMilestone.bind(this);

    App.afterTimeLog = (App.afterTimeLog || []).concat([this.updateMilestonesAndListItems]);
    App.Helpers.listenToCustomEvent(document, "completable:checkbox-update", this.refreshAfterCheckboxUpdate);
    App.Helpers.listenToCustomEvent(document, "milestone:toggle-complete", this.toggleCompleted);
    App.Helpers.listenToCustomEvent(document, "milestone:meeting-create:success", this.refreshAfterUpdate);
    App.Helpers.listenToCustomEvent(document, "milestone:task-create:success", this.refreshAfterUpdate);
    App.Helpers.listenToCustomEvent(document, "list:close-all-forms", this.refreshIfInMilestone);
  }

  toggleCompleted(event) {
    const { milestoneID, showComplete } = event.detail;
    if (milestoneID == this.listID) {
      [...this.element.querySelectorAll(".complete")].forEach(completeItem => App.Helpers[`${showComplete ? "show" : "hide"}Element`](completeItem))
    }
  }

  disconnect() {
    App.Helpers.removeCustomEventListener(document, "completable:checkbox-update", this.refreshAfterCheckboxUpdate);
  }

  refreshAfterCheckboxUpdate(event) {
    const { milestone } = event.detail;
    if (milestone == this.listID && this.openFormCount === 0) {
      this.refreshList();
    }
  }

  refreshAfterUpdate(event) {
    const { listID } = event.detail;
    if (listID == this.listID && this.openFormCount === 0) {
      this.refreshList();
      this.resetEditAllButton();
    }
  }

  refreshIfInMilestone(event) {
    const { listID } = event.detail;
    if (listID == this.listID) {
      this.refreshList();
    }
  }

  updateMilestonesAndListItems({ milestone_id, task_id, event_id }) {
    if (milestone_id == this.listID) {
      document.dispatchEvent(createCustomEvent("card-list:activities-update", this.element, { sourceListID: milestone_id }))
      document.dispatchEvent(createCustomEvent("list-item-time-log:success",  this.element, { id: task_id || event_id }))
    }
  }

  getMilestoneEl(milestoneID) {
    return this.element.id == `milestone-${milestoneID}` ? this.element : null;
  }

  resetEditAllButton() {
    document.dispatchEvent(createCustomEvent(this.element, "list:reset-edit-all", { listID: this.listID }));
  }

  //
  // GETTERS AND SETTERS
  //

  get selector() {
    return this.data.get("selector");
  }

  get timeDetailsURL() {
    return this.data.get('time-details-url');
  }

  get openFormSelector() {
    return ".card-lists--inline-activity-form--component"
  }
};



// WEBPACK FOOTER //
// ./app/components/milestones/assets/javascript/milestones-card-controller.js